import { useMutation } from '@tanstack/react-query';
import { submitSelection } from '../api/booking';
import type { ConsumerSelectRequest, ConsumerSelectResponse } from '../types/dtos';
import type { ApiError } from '../api/client';

export function useSelect(token: string) {
  return useMutation<ConsumerSelectResponse, ApiError, ConsumerSelectRequest>({
    mutationFn: (body) => submitSelection(token, body),
    retry: false,
  });
}
